import { render, staticRenderFns } from "./CollaPse.vue?vue&type=template&id=07315ae3&scoped=true"
import script from "./CollaPse.vue?vue&type=script&lang=js"
export * from "./CollaPse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07315ae3",
  null
  
)

export default component.exports